// The google_places_info poll URL for one provider's card. The base may already carry
// a query (keep_if_closed=1 for a provider the member looked up by name, NPI or EIN).
export function googlePlacesFallbackUrl(base, npi, addressHash) {
  const separator = base.includes("?") ? "&" : "?"
  return `${base}${separator}npi=${encodeURIComponent(npi)}&address_hash=${encodeURIComponent(addressHash)}`
}
